import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import logo from "../../resources/img/logoc7.png";
import styles from "./navbar.module.css";
import { Link } from "react-router-dom";

export default function NavigationBar() {
  const [isOpen, setIsOpen] = useState(false); // menú móvil
  const [desktopSubMenuOpen, setDesktopSubMenuOpen] = useState(false); // submenu desktop
  const [mobileSubMenuOpen, setMobileSubMenuOpen] = useState(false);   // submenu móvil
  const [registered, setRegistered] = useState(false);

    useEffect(() => {
         const data = localStorage.getItem("usuarioRegistrado");
       
         if (data){
            const usuarioRegistrado = JSON.parse(data);
  
            if(usuarioRegistrado.email)
               setRegistered(true); 
         }
            
       }, []);

  // cerrar todo (menú + submenú móvil)
  const handleCloseAll = () => {
    setIsOpen(false);
    setMobileSubMenuOpen(false);
  };

  // cerrar menú móvil automáticamente al pasar a desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        // ancho típico de "desktop"
        setIsOpen(false);
        setMobileSubMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <nav className={styles.navbar} style={{ position: "relative", zIndex: 1000 }}>
      <div className={styles.container}>
        <h1 className={styles.logo}>
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </h1>

        {/* Menú Desktop */}
        <ul className={styles.menu}>
          <li><Link to="/NewHere">¿Nuevo aquí?</Link></li>
          <li><Link to="/predicas">Prédicas</Link></li>
          <li><Link to="/about">Sobre nosotros</Link></li>
          {registered ? <li><Link to="/circulos">Círculos de estudio</Link></li> : null}
        </ul>

        {/* Botón del menú hamburguesa */}
        <button className={styles.menuButton} onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={30} /> : <Menu size={30} />}
        </button>
      </div>

      {/* Menú móvil */}
      {isOpen && (
        <motion.ul
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className={styles.mobileMenu}
          style={{ zIndex: 2000 }}
        >
          <li><Link to="/NewHere" onClick={handleCloseAll}>¿Nuevo aquí?</Link></li>
          <li><Link to="/predicas" onClick={handleCloseAll}>Prédicas</Link></li>
          <li><Link to="/about" onClick={handleCloseAll}>Sobre nosotros</Link></li>
          {registered ? <li><Link to="/circulos" onClick={handleCloseAll}>Círculos de estudio</Link></li> : null}
        </motion.ul>
      )}
    </nav>
  );
}
